import { render, staticRenderFns } from "./SingleNews.vue?vue&type=template&id=534dccd4"
import script from "./SingleNews.vue?vue&type=script&lang=js"
export * from "./SingleNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports